import { PatientService } from 'src/app/core/services/patient.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';
import { map, takeUntil } from 'rxjs';
import { BaseComponent } from './../../../../core/components/base/base.component';
import { FeedbackService } from './../../../../core/services/feedback.service';
import { PatientTaskService } from './../../../../core/services/patient-task.service';
import { taskAssigneeSummary } from './../../../../core/utils/task-assignees';

@Component({
  selector: 'app-patient-task-list',
  templateUrl: './patient-task-list.component.html',
  styleUrls: ['./patient-task-list.component.scss']
})
export class PatientTaskListComponent extends BaseComponent implements OnInit {
  readonly assigneeSummary = taskAssigneeSummary;
  @Input() actions: any[] = [];
  @Input() heading: string = 'TASKS';
  @Input() initialExpanded?: boolean;
  expanded?: boolean;
  @Output() expandedChange = new EventEmitter<boolean>();

  listData!: any[] | null;
  patient: any;

  constructor(
    private router: Router,
    private patientTaskService: PatientTaskService,
    private patientService: PatientService,
    fs: FeedbackService,
    md: MatDialog
  ) {
    super(fs, md);
  }

  ngOnInit(): void {
    this.loadTimelineData();
  }

  toggleExpanded() {
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
  }

  loadTimelineData(): void {
    this.patientTaskService.patientTasks$
      .pipe(
        map((consents) => {
          return this.sortTaskRecords(consents);
        }),
        takeUntil(this.destroy$),
      ).subscribe({
        next: (result) => {
          this.listData = result;
        },
        error: (err) => {
          console.error('Error loading tasks:', err);
          this.listData = [];
        }
      });
  }

  sortTaskRecords(tasks: any): any[] {

    // Group items by formatted date (no need to format date here since we're just grouping)
    const grouped = _.groupBy(tasks, item => item.date ? moment(item.date).format('YYYY-MM-DD') : moment(item.createdAt).format('YYYY-MM-DD'));

    // Sort the groups by date in descending order and transform into an array
    return _.chain(grouped)
      .map((value, key) => ({ date: key, items: value }))
      // Use the ISO date string directly for sorting
      .orderBy(group => group.date, 'desc')
      .value();

  }

  isDate(value: any): boolean {
    return !isNaN(Date.parse(value));
  }

  handleActionClick(event: MouseEvent, action: any) {
    event.preventDefault();
    event.stopPropagation();
    if (this.patientService.isRecordingLocked()) {
      return;
    }
    action.action(event);
  }


  loadItem(data: any) {
    if (this.patientService.isRecordingLocked()) {
      return;
    }
    this.patientTaskService.setEditingTask(data);
    this.router.navigate(['/patients', {
      outlets: {
        patient: ['edit-task', data.id],
      }
    }]);
  }

}
